export enum ReturnMethod
{
    Unset = "unset",
    Package = "package",
    Personal = "personal",
}
